<template>
  <div>
    <p
      v-for="(line, i) in parsed"
      :key="i"
      class="mb-0"
      :class="classNames"
    >
      <component
        :is="item.type || 'span'"
        v-for="(item, j) in line.children"
        :key="j"
      >
        {{ item.value }}
      </component>
    </p>
  </div>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    classNames: {
      type: String,
      default: '',
    },
  },
  computed: {
    parsed() {
      return this.parseText(this.text)
    },
  },
  methods: {
    parseText(text) {
      const lines = text.split('\n')

      return lines.map(line => ({
        type: 'paragraph',
        children: this.parseInline(line),
      }))
    },

    parseInline(text) {
      const regex = /(\*[^*]+\*|_[^_]+_|~[^~]+~|```[\s\S]+?```)/g

      const result = []
      let lastIndex = 0

      text.replace(regex, (match, _, index) => {
        if (index > lastIndex) {
          result.push({
            type: 'span',
            value: text.slice(lastIndex, index),
          })
        }

        if (match.startsWith('*')) {
          result.push({
            type: 'strong',
            value: match.slice(1, -1),
          })
        } else if (match.startsWith('_')) {
          result.push({
            type: 'em',
            value: match.slice(1, -1),
          })
        } else if (match.startsWith('~')) {
          result.push({
            type: 's',
            value: match.slice(1, -1),
          })
        } else if (match.startsWith('```')) {
          result.push({
            type: 'code',
            value: match.slice(3, -3),
          })
        }

        lastIndex = index + match.length
      })

      if (lastIndex < text.length) {
        result.push({
          type: 'span',
          value: text.slice(lastIndex),
        })
      }

      return result
    },
  },
}
</script>
